import {
  GET_ALL_SCRUTINY_NOTES,
  GET_ALL_SCRUTINY_NOTES_ERROR,
  GET_ALL_SCRUTINY_NOTES_SUCCESS,
  GET_ALL_SCRUTINY_NOTES_TYPE,
  GET_ALL_SCRUTINY_NOTES_TYPE_ERROR,
  GET_ALL_SCRUTINY_NOTES_TYPE_SUCCESS,
  UPDATE_SCRUTINY_STATUS,
  UPDATE_SCRUTINY_STATUS_SUCCESS,
  UPDATE_SCRUTINY_STATUS_ERROR,
} from "./actionType"

export const getallscrutinynotes = scrutinynotes => {
  return {
    type: GET_ALL_SCRUTINY_NOTES,
    payload: scrutinynotes,
  }
}

export const updateScrutinyStatus = credential => {
  return {
    type: UPDATE_SCRUTINY_STATUS,
    payload: credential,
  }
}

export const updateScrutinyStatusSuccess = scrutinynotes => {
  return {
    type: UPDATE_SCRUTINY_STATUS_SUCCESS,
    payload: scrutinynotes,
  }
}

export const updateScrutinyStatusError = scrutinynotes => {
  return {
    type: UPDATE_SCRUTINY_STATUS_ERROR,
    payload: scrutinynotes,
  }
}

export const getallscrutinynotesSuccess = scrutinynotes => {
  return {
    type: GET_ALL_SCRUTINY_NOTES_SUCCESS,
    payload: scrutinynotes,
  }
}

export const getallscrutinynotesError = scrutinynotes => {
  return {
    type: GET_ALL_SCRUTINY_NOTES_ERROR,
    payload: scrutinynotes,
  }
}
// scrutiny type 
export const getallscrutinynotestype = scrutinynotestype => {
  return {
    type: GET_ALL_SCRUTINY_NOTES_TYPE,
    payload: scrutinynotestype,
  }
}

export const getallscrutinynotestypeSuccess = scrutinynotestype => {
  return {
    type: GET_ALL_SCRUTINY_NOTES_TYPE_SUCCESS,
    payload: scrutinynotestype,
  }
}

export const getallscrutinynotestypeError = scrutinynotestype => {
  return {
    type: GET_ALL_SCRUTINY_NOTES_TYPE_ERROR,
    payload: scrutinynotestype,
  }
}
